"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var react_final_form_1 = require("react-final-form");
var react_redux_firebase_1 = require("react-redux-firebase");
var reactstrap_1 = require("reactstrap");
var ButtonPrim_1 = require("components/Buttons/ButtonPrim");
var InputSimple_1 = __importDefault(require("components/Form/InputSimple"));
var FormButton_1 = __importDefault(require("components/modules/form/FormButton"));
var PREFIX = 'ReferenceForm';
var classes = {
    button: "".concat(PREFIX, "-button"),
};
var StyledForm = (0, styles_1.styled)(react_final_form_1.Form)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.button)] = {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(2),
        },
        _b);
});
var ReferenceForm = function (_a) {
    var reference = _a.reference, closeForm = _a.closeForm, services = _a.services;
    var firebase = (0, react_redux_firebase_1.useFirebase)();
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var valuesToSend, selectedService;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    valuesToSend = __assign({}, values);
                    if ((values.serviceId && !reference.serviceName) || (reference.serviceId !== values.serviceId)) {
                        selectedService = values.serviceId && services.find(function (service) { return service.id === values.serviceId; });
                        valuesToSend.serviceName = (selectedService === null || selectedService === void 0 ? void 0 : selectedService.name) || null;
                    }
                    return [4 /*yield*/, firebase.firestore().collection('references').doc(reference.id).update(valuesToSend)];
                case 1:
                    _a.sent();
                    closeForm();
                    return [2 /*return*/];
            }
        });
    }); };
    var validate = function (_a) {
        var rePattern = _a.rePattern, keyword = _a.keyword;
        return ({
            rePattern: rePattern && !reference.reference.match(rePattern) ? "Pattern won't match rule" : undefined,
            keyword: keyword && !reference.reference.includes(keyword) ? 'Keyword not found in reference' : undefined,
        });
    };
    return ((0, jsx_runtime_1.jsx)(StyledForm, __assign({ onSubmit: onSubmit, subscription: { submitting: true }, initialValues: reference, validate: validate }, { children: function (_a) {
            var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
            return ((0, jsx_runtime_1.jsx)("form", __assign({ onSubmit: handleSubmit, noValidate: true }, { children: (0, jsx_runtime_1.jsxs)(reactstrap_1.Row, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.Col, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: InputSimple_1.default, label: "Service ID", name: "serviceId", disabled: submitting }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.Col, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: InputSimple_1.default, label: "RegEx Pattern", name: "rePattern", disabled: submitting }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.Col, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: InputSimple_1.default, label: "KeyWord", name: "keyword", disabled: submitting }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.Col, { children: [(0, jsx_runtime_1.jsx)(FormButton_1.default, __assign({ className: classes.button, disabled: submitting, color: "secondary" }, { children: "Save" })), (0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrim, __assign({ onClick: closeForm }, { children: "X" }))] })] }) })));
        } })));
};
exports.default = ReferenceForm;
